<template>
  <div class="my-contract-list">
    <div class="page-header">
      <h2>내 계약서</h2>
      <el-button @click="helpVisible = true">
        <el-icon><QuestionFilled /></el-icon>
        도움말
      </el-button>
    </div>

    <!-- 미확인 알림 배너 -->
    <el-alert
      v-if="contractStore.pendingCount > 0"
      :title="`확인이 필요한 계약서가 ${contractStore.pendingCount}건 있습니다.`"
      type="warning"
      show-icon
      style="margin-bottom: 16px"
    />

    <!-- 탭: 미확인 / 완료 -->
    <el-card>
      <el-tabs v-model="activeTab" @tab-click="fetchData">
        <el-tab-pane label="미확인" name="pending" />
        <el-tab-pane label="동의완료" name="consented" />
        <el-tab-pane label="전체" name="all" />
      </el-tabs>

      <el-table :data="contractStore.myContracts" @row-click="goDetail" style="cursor:pointer">
        <el-table-column prop="contract_number" label="계약번호" width="160" />
        <el-table-column prop="contract_title" label="계약서명" min-width="250" />
        <el-table-column prop="template_category_display" label="분류" width="120" />
        <el-table-column label="상태" width="100">
          <template #default="{ row }">
            <el-tag :type="statusTag(row.status)" size="small">{{ row.status_display }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="기한" width="120">
          <template #default="{ row }">
            <span :style="{ color: isOverdue(row.deadline) ? '#F56C6C' : '' }">
              {{ row.deadline?.substring(0, 10) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="동의일" width="120">
          <template #default="{ row }">{{ row.consented_at?.substring(0, 10) || '-' }}</template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 도움말 패널 -->
    <HelpPanel v-model="helpVisible" :content-path="'screens/my-contract'" />
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useContractStore } from "@/stores/contractStore";
import { QuestionFilled } from "@element-plus/icons-vue";
import HelpPanel from "@/components/help/HelpPanel.vue";

const helpVisible = ref(false);

const router = useRouter();
const contractStore = useContractStore();
const activeTab = ref("pending");

onMounted(() => {
  contractStore.fetchPendingCount();
  fetchData();
});

function fetchData() {
  const params = {};
  if (activeTab.value === "pending") {
    params.status = "PENDING,READ";
  } else if (activeTab.value === "consented") {
    params.status = "CONSENTED";
  }
  contractStore.fetchMyContracts(params);
}

function goDetail(row) {
  router.push(`/my-contracts/${row.id}`);
}

function statusTag(s) {
  return { PENDING: "info", READ: "warning", CONSENTED: "success", REJECTED: "danger", EXPIRED: "" }[s] || "";
}

function isOverdue(deadline) {
  return deadline && new Date(deadline) < new Date();
}
</script>

<style scoped>
.page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
</style>
